import { Component} from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { ActivatedRoute } from '@angular/router';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-intuitive',
  templateUrl: './intuitive.component.html',
  styleUrls: ['./intuitive.component.css']
})
export class IntuitiveComponent extends GeneralExerciseComponent {

  cloe: string;
  variations: string[];
  selected: boolean[];
  errorCount: number;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration(){
    this.cloe = this.configuration.typespecifics.cloe;
    this.variations = this.configuration.typespecifics.variations;
    this.errorCount = this.configuration.typespecifics.errorCount;
    this.selected = new Array(this.variations.length).fill(false);
  }

  setTypeSpecificsFromState(){
    if(this.state.typespecific){
      if(this.state.typespecific.selected){
        this.selected = this.state.typespecific.selected;
      }
    }
  }

  computeState(){
    this.state.typespecific.selected = this.selected;
  }

  checkSolution(){
    let solution = this.variations.map((v) => this.selfcorrectingService.distance(v, this.cloe) <= this.errorCount);
    if(solution.filter((v, i)=> v!=this.selected[i]).length == 0){
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get("notYetCorrect"), "danger", 10000);
    }
  }

  evaluate():number[]{
    let solution = this.variations.map((v) => this.selfcorrectingService.distance(v, this.cloe) <= this.errorCount);
    let sum = 0;
    for(let i = 0; i < this.selected.length; i++){
      if(this.selected[i] == solution[i]){
        sum++;
      }
    }
    return [sum/this.selected.length, 1];
  }


}
